import { useFormContext, useWatch } from "react-hook-form";

import { useRateFieldName } from "../../../hooks/useRateFieldName";
import { useRateRenewalPrices } from "../../../hooks/useRateRenewalPrices";

import { getRenewalPriceChange, RenewalPriceChange } from "./getRenewalPriceChange";

import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export const useRenewalPriceChange = (): (RenewalPriceChange & { newAmount: number; isGroup: boolean }) | null => {
  const { control } = useFormContext<StepTicketsFormData>();
  const newAmount = useWatch({ control, name: useRateFieldName("amount") });
  const isPayWhatYouCan = useWatch({ control, name: useRateFieldName("isPayWhatYouCan") });
  const isGroupMembership = useWatch({ control, name: useRateFieldName("isGroupMembership") });
  const isGroup = useWatch({ control, name: useRateFieldName("isGroup") });
  const { lastPaidPrices } = useRateRenewalPrices();

  if (lastPaidPrices.length === 0 || isPayWhatYouCan || typeof newAmount !== "number") {
    return null;
  }

  const renewalPriceChange = getRenewalPriceChange({ lastPaidPrices, newAmount });
  return renewalPriceChange
    ? { ...renewalPriceChange, newAmount, isGroup: Boolean(isGroupMembership || isGroup) }
    : null;
};
